import { useCallback } from 'react'

import { useUpdateZervantDocumentTemplateSettings } from '../../../hooks/useUpdateZervantDocumentTemplateSettings'
import { getCustomTemplateSettingsPayload } from '../../../utils/getCustomTemplateSettingsPayload'
import type { LogoAndBrandingSettingsFormValues } from '../types/logoAndBrandingSettingsFormValues'

export const useUpdateLogoAndBrandingTemplateSettings = () => {
  const { mutateAsync: update, isProcessing } = useUpdateZervantDocumentTemplateSettings()

  const updateLogoAndBrandingTemplateSettings = useCallback(
    (formData: LogoAndBrandingSettingsFormValues) => {
      const {
        shouldApplyTemplateColorToColumnHeaders,
        shouldApplyTemplateColorToDividers,
        shouldApplyTemplateColorToHeader,
        shouldApplyTemplateColorToTotal,
        templateColor,
        templateFont,
      } = formData

      return update(
        getCustomTemplateSettingsPayload({
          shouldApplyTemplateColorToColumnHeaders,
          shouldApplyTemplateColorToDividers,
          shouldApplyTemplateColorToHeader,
          shouldApplyTemplateColorToTotal,
          templateColor,
          templateFont,
        }),
      )
    },
    [update],
  )

  return { update: updateLogoAndBrandingTemplateSettings, isProcessing }
}
